const COURSE_INFO = `Wellness Buddy\n
Features:\n
1) daily checkin that includes mood rating, stress rating, life appraisal rating;\n
2) avatar customziation: customize the avatar for your vitual wellness buddy when you first signup and can change the look later in the profile page\n
3) data visualization: check changes over time on dashboard page\n
4) compare one's score to the overall cohort score (z-score)\n
5) set customized daily email reminder to checkin\n
6) leaderboard: top 10 app users who check in the most will be on the leaderboard\n
Goal:\n
1) improve overall wellbeing. studies have suggested that completing daily checkins can be helpful to decrease stress and negative mood.\n
2) check one's own status and compare to the commmunity, realizing that you're not alone in your circle.\n
3) Only answer Wellness Buddy related questions, otherwise, kindly ask them to login or sign up for any personal related questions.\n
`;

const FEEDBACK_MSG = [
    'acknowledge that user is going through a difficult time, Suggest engaging in self-care or reaching out to support for help.\n',
    'acknowledge that user might be facing some challenges. Offer some encouragement to keep going and pushing through it!\n',
    'praise the user for their positive state of mind. Stay encouraged and savour these good moments.\n',
];

export { COURSE_INFO, FEEDBACK_MSG };
